import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { LoginScreen } from "../components/LoginScreen";

export function CallbackPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      void navigate("/", { replace: true });
    }
  }, [auth.isAuthenticated, navigate]);

  if (auth.error) {
    return (
      <div className="flex min-h-screen items-center justify-center p-8">
        <div className="max-w-md text-center">
          <p className="text-sm uppercase tracking-widest text-[color:var(--color-brand-orange)]">
            Sign-in failed
          </p>
          <p className="mt-3 text-white/70">{auth.error.message}</p>
        </div>
      </div>
    );
  }

  return <LoginScreen label="Completing sign-in…" />;
}
